import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { CreateNoteComponent } from 'app/note/components/create-note/create-note.component';
import { NoteEditComponent } from 'app/note/components/note-edit/note-edit.component';
// Notes
import { ViewNotesComponent } from 'app/note/components/view-notes/view-notes.component';
import { NoteDialogComponent } from 'app/note/dialogs/note-dialog/note-dialog.component';
import {
  NoteEditDialog
} from 'app/note/dialogs/note-edit-dialog/note-edit-dialog.component';
import { SharedModule } from 'shared/shared.module';
import { CreateAndViewNotesComponent } from './components/create-and-view-notes/create-and-view-notes.component';
import { ViewNoteComponent } from './components/view-note/view-note.component';
import { NoteEffects } from './note.effects';

const COMPONENTS = [
  NoteEditComponent,
  ViewNotesComponent,
  ViewNoteComponent,
  CreateNoteComponent,
  CreateAndViewNotesComponent
];

const DIALOGS = [
  NoteDialogComponent,
  NoteEditDialog
];
/**
 * Everything in this module is shared
 */
@NgModule({
  imports: [
    SharedModule,
    EffectsModule.forFeature([NoteEffects]),
  ],
  declarations: [
    ...COMPONENTS,
    ...DIALOGS
  ],
  providers: [],
  exports: [
    // Components
    ...COMPONENTS,
    ...DIALOGS
  ]
})
export class NoteModule { }
